import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DashboardService } from 'src/app/dashboard/dashboard.service';
import { WorkspaceNewTabViewMode, WorkspaceTemplateViewMode } from 'src/shared/models/dashboard.model';

@Component({
    selector: 'cv-workspace-new-tab-landing',
    templateUrl: './workspace-new-tab-landing.component.html',
    styleUrls: ['./workspace-new-tab-landing.component.scss']
})
export class WorkspaceNewTabLandingComponent implements OnChanges {

    @Input() workspaceKey;

    newHovered = false;
    existingHovered = false;
    templateHovered = false;

    constructor(
        private dashboardService: DashboardService,
    ) { }

    get hasDashboardAccess() { return this.dashboardService.permissions.DashboardNew; }
    get hasExistingDashboards() { return this.dashboardService.availableDashboards?.length > 0; }
    get isActiveDashboard() { return this.dashboardService.activeDashboard.key === null }
    get viewMode() { return this.dashboardService.newTabSelectionView; }
    get templateViewMode() { return this.dashboardService.templateView; }

    // expose enum to markup
    get WorkspaceNewTabViewMode() { return WorkspaceNewTabViewMode; }
    get WorkspaceTemplateViewMode() { return WorkspaceTemplateViewMode; }

    initialize() {

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.workspaceKey?.isFirstChange && changes.workspaceKey?.currentValue) {
            this.initialize();
        }
    }

    openNewDashboardView() {
        this.newHovered = false;
        this.dashboardService.newTabSelectionView = WorkspaceNewTabViewMode.New;
    }

    openExistingView() {
        this.existingHovered = false;
        this.dashboardService.newTabSelectionView = WorkspaceNewTabViewMode.Existing;
    }

    openTemplateView() {
        this.templateHovered = false;
        this.dashboardService.newTabSelectionView = WorkspaceNewTabViewMode.Templates;
    }
}
